<template>
  <page>
    <v-container fluid grid-list-md>

      <v-layout row wrap>
        <v-flex xs12>
          <form>
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <v-card-text>
                      <v-container fluid grid-list-lg>
                        <v-layout row wrap>
                          <v-flex xs6 md6 lg6>
                            <v-text-field
                              v-model="filters.ttyNo"
                              :label="labels.ttyNo"
                              :error-messages="errors.collect('filters.ttyNo')"
                              data-vv-name="filters.ttyNo"
                              :data-vv-as="labels.ttyNo"
                              append-icon="mdi-magnify"
                              @click:append="getHelpList('ttyNo')"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 md6 lg6>
                            <v-text-field
                              v-model="filters.uwYr"
                              :label="labels.uwYr"
                              :error-messages="errors.collect('filters.uwYr')"
                              data-vv-name="filters.uwYr"
                              :data-vv-as="labels.uwYr"
                              v-validate="'numeric'"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                      <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </form>
        </v-flex>
      </v-layout>
      <v-spacer class="mt-2"></v-spacer>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-layout row wrap>
              <v-flex xs12>
                <v-card-title>
                  <v-spacer></v-spacer>
                  <!-- <v-btn color="primary" dark class=" mr-2" @click="doNew">
                    {{ labels.newButton }}
                    <v-icon right>mdi-plus</v-icon>
                  </v-btn> -->
                  <v-flex xs12>
                    <message :messages="messages"></message>
                  </v-flex>
                </v-card-title>
                <v-flex xs12>
                  <v-card>
                    <v-data-table
                      :headers="headers"
                      :items="items"
                      :search="search"
                      :footer-props="{'items-per-page-options': itemsPerPage }"
                      :server-items-length="totalItems"
                      v-bind:options.sync="pagination"
                      item-key="name"
                      :loading="loading"
                      :no-data-text="noDataText"
                      :custom-filter="customSearch"
                    >
                      <template v-slot:item="row"
                        ><tr>
                          <td class="text-xs-left">{{ row.item.riType }}</td>
                          <td class="text-xs-left">{{ row.item.ttyNo }}</td>
                          <td class="text-xs-left">{{ row.item.uwYr }}</td>
                          <td class="text-xs-left">{{ row.item.ttyName }}</td>
                          <td class="text-xs-left">{{ formatDate(row.item.comDate) }}</td>
                          <td class="text-xs-left">{{ formatDate(row.item.expDate) }}</td>
                          <td class="table-action-header">
                            <table-action
                              :rowData="row"
                              query
                              @query="doQuery(row.item)"
                              review
                              @review="doReview(row.item)"
                              remove
                              @remove="doPromptRemove(row.item)"
                            ></table-action>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>

      <v-dialog v-model="showTtyRefHelplist" width="900px" persistent>
        <ttyRef-help-list @close="doClose" @selectTtyRef="doAssign($event)"></ttyRef-help-list>
      </v-dialog>

      <confirm v-model="promptRemove" @ok="doDelete">
        Are you sure to delete the selected Treaty Details?
        <p>
          RI Type: {{ selected.riType }}, Treaty Ref: {{ selected.ttyNo }},
          UW Year: {{ selected.uwYr }}, Treaty Name: {{ selected.ttyName }},
          Com Date: {{ formatDate(selected.comDate) }}, Exp Date: {{ formatDate(selected.expDate) }}
        </p>
      </confirm>
    </v-container>

  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import TtyRefHelplist from './helplist/TtyRefHelplist'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayDate } from '@/utils/date'
import clone from 'clone'

export default {
  data() {
    return {
      loading: false,
      promptRemove: false,
      showTtyRefHelplist: false,
      items: [],
      totalItems: 0,
      selected: {
        riType: null,
        ttyNo: null,
        uwYr: null,
        ttyName: null,
        comDate: null,
        expDate: null
      },
      toggleArray: [false],
      labels: {
        // newButton: 'New Treaty',
        ttyNo: 'Treaty Reference',
        uwYr: 'Underwriting Year'
      },
      filters: {
        ttyNo: null,
        uwYr: null
      },
      headers: [
        { text: 'RI Type', value: 'riType' },
        { text: 'Treaty Ref', value: 'ttyNo' },
        { text: 'UW Year', value: 'uwYr' },
        { text: 'Treaty Name', value: 'ttyName' },
        { text: 'Com Date', value: 'comDate' },
        { text: 'Exp Date', value: 'expDate' },
        TableConst.tableActionHeader
      ],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    doInit() {
      this.fetchData(false)
    },
    doClearFilters() {
      this.filters.ttyNo = null
      this.filters.uwYr = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.pagination.page = 1
      this.fetchData(false)
    },
    async fetchData(options) {
      this.resetMessages()
      const apiURI = this.menu.getTreatyDetails
      if (apiURI) {
        this.loading = true
        try {
          const { page, itemsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let massageFilters = clone(this.filters)
          const result = await this.$http.get(
            filterQuery(expandURI(apiURI, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((ttyDetails) => {
                const convertList = {
                  riType: ttyDetails.riType,
                  ttyNo: ttyDetails.ttyNo,
                  uwYr: ttyDetails.uwYr,
                  ttyName: ttyDetails.ttyName,
                  comDate: ttyDetails.comDate,
                  expDate: ttyDetails.expDate
                }
                this.items.push(convertList)
              })
            }
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
      this.loading = false
    },
    doNew() {
      this.$router.push({ name: 'treatyDetailsReview', params: { treatyDetails: 'new', tranMode: 'New' } })
    },
    doQuery(data) {
      this.$router.push({ name: 'treatyDetailsReview', params: { treatyDetails: data, tranMode: 'Query' } })
    },
    doReview(data) {
      this.$router.push({ name: 'treatyDetailsReview', params: { treatyDetails: data, tranMode: 'Review' } })
    },
    doDelete() {
      this.resetMessages()
      if (this.selected) {
        const apiURI = this.menu.deleteTreatyDetails
        if (apiURI) {
          const expand = {
            riType: this.selected.riType,
            ttyNo: this.selected.ttyNo,
            uwYr: this.selected.uwYr,
            ttyName: this.selected.ttyName,
            comDate: this.selected.comDate,
            expDate: this.selected.expDate
          }
          this.$http
            .post(apiURI, expand)
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.doInit()
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    doPromptRemove(data) {
      this.resetMessages()
      this.selected = data
      this.promptRemove = true
      this.selected.riType = data.riType
      this.selected.ttyNo = data.ttyNo
      this.selected.uwYr = data.uwYr
      this.selected.ttyName = data.ttyName
      this.selected.comDate = data.comDate
      this.selected.expDate = data.expDate
    },
    getHelpList(fieldName) {
      switch (fieldName) {
        case 'ttyNo':
          this.fieldName = 'ttyNo'
          this.showTtyRefHelplist = true
          break
        default:
          this.fieldName = undefined
          this.showTtyRefHelplist = false
      }
    },
    doAssign(treatyObj) {
      switch (this.fieldName) {
        case 'ttyNo':
          this.filters.ttyNo = treatyObj.ttyNo
          break
        default:
          this.fieldName = undefined
          this.showTtyRefHelplist = false
      }
    },
    doClose() {
      this.resetMessages()
      this.showTtyRefHelplist = false
      setTimeout(() => {
        this.showTtyRefHelplist = false
      }, 500)
    },
    formatDate(date) {
      return formatDisplayDate(date)
    }
  },
  computed: {
    menu() {
      return this.$store.state.treatyParam.menu
    }
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  mixins: [TableConst.default, MessageMixin],
  components: {
    'ttyRef-help-list': TtyRefHelplist
  }
}
</script>
